import { initClickTracker } from './core/click-tracker'

const tracker = initClickTracker({
    endpoint: baseURL + '/click-events'
});

require('./regular/index');
require('./modules/index');



// WEBPACK FOOTER //
// ./resources/assets/js/app.js